module.exports = __webpack_public_path__ + "img/goldregen-2020-101.da6727b1.jpg";